import script from "./feedback-hero.vue?vue&type=script&setup=true&lang=js"
export * from "./feedback-hero.vue?vue&type=script&setup=true&lang=js"

import "./feedback-hero.vue?vue&type=style&index=0&id=35e0e90c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e0e90c"]])

export default __exports__